export const GET_CUSTOMER_PORTFOLIOS_DATA = "GET_CUSTOMER_PORTFOLIOS_DATA"
export const GET_CUSTOMER_PORTFOLIOS_DATA_SUCCESS = "GET_CUSTOMER_PORTFOLIOS_DATA_SUCCESS"

export const GET_TOTAL_VALUES_DATA = "GET_TOTAL_VALUES_DATA"
export const GET_TOTAL_VALUES_DATA_SUCCESS = "GET_TOTAL_VALUES_DATA_SUCCESS"

export const GET_INVESTOR_ASSET_ALLOCATION_DATA_SUCCESS = "GET_INVESTOR_ASSET_ALLOCATION_DATA_SUCCESS"
export const GET_INVESTOR_ASSET_ALLOCATION_DATA = "GET_INVESTOR_ASSET_ALLOCATION_DATA"

export const GET_BENCHMARK_PERFORMANCE_DATA_SUCCESS = "GET_BENCHMARK_PERFORMANCE_DATA_SUCCESS"
export const GET_BENCHMARK_PERFORMANCE_DATA = "GET_BENCHMARK_PERFORMANCE_DATA"

export const GET_SCHEME_DETAILS_DATA_SUCCESS = "GET_SCHEME_DETAILS_DATA_SUCCESS"
export const GET_SCHEME_DETAILS_DATA = "GET_SCHEME_DETAILS_DATA"

export const GET_AMC_PERFORMANCE_ANALYSIS_DATA_SUCCESS = "GET_AMC_PERFORMANCE_ANALYSIS_DATA_SUCCESS"
export const GET_AMC_PERFORMANCE_ANALYSIS_DATA = "GET_AMC_PERFORMANCE_ANALYSIS_DATA"

export const GET_ANALYTICS_HOLDINGS_DATA_SUCCESS = "GET_ANALYTICS_HOLDINGS_DATA_SUCCESS"
export const GET_ANALYTICS_HOLDINGS_DATA = "GET_ANALYTICS_HOLDINGS_DATA"

export const GET_HOLDING_PERIOD_ANALYSIS_DATA_SUCCESS = "GET_HOLDING_PERIOD_ANALYSIS_DATA_SUCCESS"
export const GET_HOLDING_PERIOD_ANALYSIS_DATA = "GET_HOLDING_PERIOD_ANALYSIS_DATA"

export const GET_MARKET_CAP_ALLOCATION_DATA_SUCCESS = "GET_MARKET_CAP_ALLOCATION_DATA_SUCCESS"
export const GET_MARKET_CAP_ALLOCATION_DATA = "GET_MARKET_CAP_ALLOCATION_DATA"

export const GET_ASSET_ALLOCATION_GUIDELINE_DATA_SUCCESS = "GET_ASSET_ALLOCATION_GUIDELINE_DATA_SUCCESS"
export const GET_ASSET_ALLOCATION_GUIDELINE_DATA = "GET_ASSET_ALLOCATION_GUIDELINE_DATA"

export const GET_PORTFOLIO_HEALTH_DATA_SUCCESS = "GET_PORTFOLIO_HEALTH_DATA_SUCCESS"
export const GET_PORTFOLIO_HEALTH_DATA = "GET_PORTFOLIO_HEALTH_DATA"
export const GET_PORTFOLIO_COMPLIANCE_DATA_SUCCESS = "GET_PORTFOLIO_COMPLIANCE_DATA_SUCCESS"
export const GET_PORTFOLIO_COMPLIANCE_DATA = "GET_PORTFOLIO_COMPLIANCE_DATA"

export interface GetCustomerPortfoliosRequestBody {
    rmId: string;
    clientCode: string;
}

export interface GetCustomerPortfoliosResponseBody {
    isSuccess: boolean;
    portfolios: {
        portfolioId: string;
        clientCode: string;
        rmId: string;
        portfolioName: string;
    }[];
    message: string
}

export interface GetTotalValuesRequestBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
    assetGroup: string | null;
}

export interface GetTotalValuesResponseBody {
    result: {
        totalInvestedValue?: number;
        totalMarketValue?: number;
        gainLoss?: number;
        totalInvestors?: number;
        irr?: number;
        percentage?: number;
        alpha?: number;
        beta?: number;
    },
    message: string;
    isSuccess: boolean;
}

export interface GetInvestorAssetAllocationRequestBody {
    clientCode: string;
    category: string;
    rmId: string;
    portfolio: string
}

export interface GetInvestorAssetAllocationResponseBody {
    result: {
        data: Array<Array<number | string>>;
        labelData: {
            label: string;
            value: number;
        }[];
        totalValue: {
            label: string;
            value: number;
        };
        growth: {
            mutualFunds: number;
            equity: number;
            pms: number;
            bonds: number;
            alternatives: number;
        }
    },
    message: string;
    isSuccess: boolean;
    portfolio: string;
}

export interface GetBenchmarkPerformanceRequestBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
    assetGroup: null
}

export interface GetBenchmarkPerformanceResponseBody {
    result: {
        data1: Array<[number, number]>;
        data2: Array<[number, number]>;
        data3: Array<[number, number]>;
        label1: string;
        label2: string;
        label3: string;
    };
    message: string;
    isSuccess: boolean;
}

export interface GetSchemeDetailsRequestBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
    sortItem: string;
    order: string;
    currentPage: number;
    rowsPerPage: number;
    assetGroup: string;
}

export interface SchemeDetailsData {
    schemeName?: string;
    investedValue?: number;
    marketValue?: number;
    categoryName?: string;
    companyName?: string;
    schemeLogo?: string;
    percentage?: {
        amount?: number;
        percentage?: number;
    };
    units?: number;
    realGainLossPercentage?: {
        amount?: number;
        percentage?: number;
    };
    inflow?: number;
    outflow?: number;
    exposure?: number;
    noOfShares?: number;
    shares1Year?: string;
    avgCostPrice?: number;
    week52High?: number;
    week52Low?: number;
    eps?: number;
    pe?: number;
    pb?: number;
    marketCapitalisation?: number;
    dividend?: number;
    sectorPE?: number;
    currentPrice?: number;
    expenseRatio?: number;
    investedOn?: string;
    periodOfInvestment?: number;
    irr?: number;
    amcId?: string;
    folioNo?: string;
}
export interface GetSchemeDetailsResponseBody {
    result: SchemeDetailsData[]
    totalLength: 6,
    message: "Success",
    isSuccess: true
}

export interface GetAmcPerformanceAnalysisRequestBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
    category: string;
    assetGroup: string;
    sortItem: string;
    order: string;
}

export interface AmcPerformanceAnalysisData {
    amcname: string;
    marketValue: number;
    equity: number;
    debt: number;
    hybrid: number;
    others: number;
    investedValue: number;
    unRelease: number;
    release: number;
    dividend: number;
    irr: number;
    holding: number;
}

export interface GetAmcPerformanceAnalysisResponseBody {
    result: AmcPerformanceAnalysisData[];
    message: string;
    isSuccess: boolean;
}

export interface GetAnalyticsHoldingsRequestBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
}

export interface AnalyticsHoldingsData {
    categoryName: string;
    categoryPerentage: number;
    sectors: {
        sectorName: string;
        allocation: number;
    }[];
    companies: {
        companyName: string;
        allocation: number;
    }[];
}

export interface GetAnalyticsHoldingsResponseBody {
    result: AnalyticsHoldingsData[];
    message: string;
    isSuccess: boolean;
}

export interface GetHoldingPeriodAnalysisRequestBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
}

export interface HoldingPeriodSchemeData {
    quantity: number;
    saleDate: string;
    schemeName: string;
}

export interface GetHoldingPeriodAnalysisResponseBody {
    result: {
        data: Array<[string, number]>;
        labelData: {
            label: string;
            value: number
        }[];
        longTermSchemes: Array<HoldingPeriodSchemeData>;
        shortTermSchemes: Array<HoldingPeriodSchemeData>;
    },
    message: string;
    isSuccess: boolean;
}

export interface GetMarketCapAllocationRequestBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
    assetGroup: string
}

export interface GetMarketCapAllocationResponseBody {
    result: {
        data: Array<Array<number | string>>;
        labelData: {
            label: string;
            value: number;
        }[];
        totalValue: {
            label: string;
            value: number;
        };
    };
    message: string;
    isSuccess: boolean;
}

export interface GetAssetAllocationGuidelineBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
    assetGroup: null;
}

export interface AssetAllocationGuidelineResBody {
    assetGroup: string;
    assetGroupName: string;
    lowerPar: number;
    upperPar: number;
    actualPortfolio: number;
}

export interface AssetAllocationGuidelineRes {
    isSuccess: boolean;
    message: string;
    result: Array<AssetAllocationGuidelineResBody>
}

export interface GetPortfolioHealthBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
    assetGroup: null;
}

export interface PortfolioHealthData {
    label: string;
    status: boolean;
}

export interface PortfolioHealthResBody {
    isSuccess: boolean;
    message: string;
    result: Array<PortfolioHealthData>

}
export interface GetPortfolioComplianceRequestBody {
    rmId: string;
    clientCode: string;
    portfolioId: string;
    assetGroup: null
}

export interface GetPortfolioComplianceResponseBody {
    result: {
        label: string;
        lowerPer: number;
        upperPer: number;
        status: boolean;
    }[];
    message: string;
    isSuccess: boolean
}